import { render, staticRenderFns } from "./Reset-Password.vue?vue&type=template&id=58127ed8&scoped=true&"
import script from "./Reset-Password.vue?vue&type=script&lang=js&"
export * from "./Reset-Password.vue?vue&type=script&lang=js&"
import style0 from "./Reset-Password.vue?vue&type=style&index=0&id=58127ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58127ed8",
  null
  
)

export default component.exports